import { Link, useLocation } from "react-router-dom";
import { Search } from "lucide-react";

// Persistent way to reach Pula Search from any screen. Hidden on the search page itself.
export function SearchFab() {
  const { pathname } = useLocation();
  if (pathname === "/search") return null;
  return (
    <Link to="/search" data-testid="search-fab" aria-label="Open Pula Search" title="Pula Search"
      className="group fixed left-3 top-1/2 -translate-y-1/2 z-40 inline-flex items-center gap-2 rounded-full bg-pula-ink text-white shadow-lg shadow-black/25 pl-3 pr-3.5 py-2.5 hover:bg-pula-green transition-colors">
      <Search className="w-5 h-5 shrink-0" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold opacity-0 group-hover:max-w-[110px] group-hover:opacity-100 transition-all duration-300">Search Pula</span>
    </Link>
  );
}
